module.exports = __webpack_public_path__ + "c469b6ef8ee990b845b22c57042562a0.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light-Oblique.eot
// module id = 377
// module chunks = 0